import React from 'react'
import tripIcon from '../assets/images/icons/trip.png'

const TripDetailButton = ({ onClick, active = false }) => {
  return (
    <button
      className="vehicle-detail-button"
      disabled={!active}
      style={{
        border: active ? '1.5px solid #0A303B' : '1.5px solid #999',
        background: active ? '#3BC6C4' : '#f5f5f5',
        borderRadius: 6,
        height: 28,
        padding: '1px 7px 3px 5px',
        cursor: active ? 'pointer' : 'default',
        fontWeight: 700,
        boxShadow: active
          ? '0 2px 18px rgba(16,124,107,0.65), 0 0 6px rgba(16,124,107,0.55)'
          : '0 1px 8px rgba(0,0,0,0.30)',
        transition: 'transform 0.05s ease, box-shadow 0.1s ease',
        outline: 'none',
        opacity: active ? 1 : 0.55
      }}
      onMouseEnter={(e) => {
        if (!active) return
        e.currentTarget.style.background = '#2da9a4'
      }}
      onMouseLeave={(e) => {
        if (!active) return
        e.currentTarget.style.background = '#3BC6C4'
        e.currentTarget.style.transform = 'scale(1)'
        e.currentTarget.style.boxShadow = active
          ? '0 2px 18px rgba(16,124,107,0.65), 0 0 6px rgba(16,124,107,0.55)'
          : '0 1px 8px rgba(0,0,0,0.30)'
      }}
      onMouseDown={(e) => {
        if (!active) return
        e.currentTarget.style.transform = 'scale(0.96)'
        e.currentTarget.style.boxShadow = '0 0px 4px rgba(0,0,0,0.25)'
      }}
      onMouseUp={(e) => {
        if (!active) return
        e.currentTarget.style.transform = 'scale(1)'
        e.currentTarget.style.boxShadow =
          '0 2px 10px rgba(165,232,195,0.95)'
        e.currentTarget.blur()
      }}
      onClick={(e) => {
        if (!active) return
        e.stopPropagation()
        if (onClick) onClick(e)
      }}
    >
      <img
        src={tripIcon}
        alt="trip"
        style={{
          width: 26,
          height: 24,
          display: 'block'
        }}
      />
    </button>
  )
}

export default TripDetailButton